import React, { useEffect, useReducer, createContext, useContext, useState } from 'react';
import { format, parse } from 'date-fns';
import { CalendarIntakeBookContext } from '../contexts/CalendarIntakeBookProvider';
import { fetchMonthlyIntakeBookDetails, submitMonthlyIntakeBookDetails, submitSelectedDailyIntakeDetails,submitMonthlyUnblockContractRequest} from '../actions/actionSelectors';
import { downloadMonthlyIntakeBook} from '../../store/actionSelectors';
import {downloadMonthlyIntakeBookHandler} from '../../common/utility/utility';
import { FETCH_INTAKEBOOK_DATE_MONTHLY_DETAILS, UPDATE_MONTHLY_INTAKE, TOGGLE_UPLOAD_FILE_MODEL, 
    CANCEL_CHANGE_REQUEST, SET_CHANGE_REQUEST_DATA, SUBMIT_CHANGE_REQUEST, UPDATE_SELECTED_CHECKBOX, 
    SUBMIT_SELECTED_INTAKE_BOOK_SUCCESS, SUBMIT_SELECTED_INTAKE_BOOK_FAILED,SET_SELECTEDINTAKEBOOK_DATA_REQUEST,
    SET_SELECT_UNBLOCK_REQUEST_INTAKEBOOK,SET_SELECTEDINTAKEBOOK_DATA,TOGGLE_MONTHLY_UNBLOCK_REQUEST_MODEL ,SUBMIT_MONTHLY_UNBLOCK_REQUEST,
    MONTHLY_UNBLOCK_REQUEST_NOT_ALLOWED} from '../actions/actionTypes';
import { monthlyIntakeBookReducer } from '../actions/monthly-intakebook-reducer';
import config from '../../common/const/config';
import { RequestStatus } from '../../common/const/RequestStatus';
import {isValueNullOrUndefinedOrEmpty} from '../../common/utility/utility';
import TranslationErrorPopup from '../../components/UI/Modal/translationErrorPopup';

const initialState = {
    monthlyIntakeBookDetails: null,
    selectedIntakeDtl: null,
    selectedRowIndex : null,
    showUploadFileModel: false,
    acceptFileType : undefined,
    modelHeaderTitle : null,
    showUnblockMonthlyRequestModel: false
}

export const MonthlyIntakeBookContext = createContext();

export function MonthlyIntakeBookProvider(props) {

    const [state, dispatch] = useReducer(monthlyIntakeBookReducer, initialState);
    const { intakeBookStartDate, isDateChangeFlag, newSelectedDate, setMonthlyIntakeBookDate,
        setErrorOrWarningHandler, ShowOrHideLoader, resetSubmittedAndErrorFlags, setChangeRequestNumber,setUnblockFromDateAndContractCode } = useContext(CalendarIntakeBookContext);
    const { monthlyIntakeBookDetails, selectedIntakeDtl, selectedRowIndex, showUploadFileModel,
            acceptFileType, modelHeaderTitle,showUnblockMonthlyRequestModel} = state;

            const [showPopup,setPopup] = useState(false)

    const checkIfModification = () =>{
        let error = "";       
        let isModificationError = false;

        monthlyIntakeBookDetails && monthlyIntakeBookDetails.map((d) => {
            if (!d.isSubmitted && !d.isLocked)  {                
                if(d.intakeBookFile) {
                    error = "modification_notsaved";            
                }   
            } else if(d.isSubmitted && d.isChangeRequestAllowed && d.changeRequest.changeRequestStatus === 0 ) {
                if (!isValueNullOrUndefinedOrEmpty(d.changeRequest.businessPartnerRemarks)){
                    error = "modification_notsaved";
                }
            }
        });

        if (error.trim() !== "") {
            isModificationError = true;
        }

        if (isModificationError) {            
            setErrorOrWarningHandler(isModificationError, error, false, true, "unsaved_changes", false, false)
        } 
        else 
        {
            if(props.isLogout) {
                props.clearSessionData();
            }
            else {
                setMonthlyIntakeBookDate(newSelectedDate);
            }
        }
    }

    useEffect(() => {
        if(isDateChangeFlag || props.isLogout) {
            checkIfModification();
        }
    }, [isDateChangeFlag, props.isLogout]);    

    const fetchMonthlyIntakeBookDetailsHandler = async (intakeBookDate) => {
        ShowOrHideLoader(true);
        await fetchMonthlyIntakeBookDetails(props.BusinessPartnerCode, intakeBookDate)
            .then((data) => {
                dispatch({
                    type: FETCH_INTAKEBOOK_DATE_MONTHLY_DETAILS,
                    payload: {
                        monthlyIntakeBookDetails: data && typeof(data) !== 'string' ? data : []
                    }
                });
                ShowOrHideLoader(false);
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_INTAKEBOOK_DATE_MONTHLY_DETAILS,
                    payload: {
                        monthlyIntakeBookDetails: []
                    }
                });
                setErrorOrWarningHandler(true,  "wentwrong", false, true, "intakeBookSubmission",false, false);
            })
    }

    useEffect(() => {
        if(intakeBookStartDate) {
            const intakeBookDate = format(parse(intakeBookStartDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" )
            fetchMonthlyIntakeBookDetailsHandler(intakeBookDate)
        }
    }, [intakeBookStartDate]);

    const handlerOnIntakeBookIconClick = (row, rowIndex) => { 

    let titleTag = document.getElementById('titleTag')

    if(titleTag.hasAttribute('_msthash')){
        setPopup(true)
    }      
    else{               
        if(row)
        {         
            if(row.isLocked)
            {
                setErrorOrWarningHandler(true,  "revenueFiguresUnsubmitted", false, true, "intakeBookSubmission", false, false);
            }                
            else{
                row={
                    ...row,
                    isFileUploadedError: false, 
                }
                dispatch({ type: UPDATE_MONTHLY_INTAKE, 
                    payload: { 
                        selectedIntakeDtl: row,
                        selectedRowIndex : rowIndex,
                        changeRequestData : row                                
                    } 
                })
                dispatch({ type: TOGGLE_UPLOAD_FILE_MODEL, 
                    payload: {                        
                        showUploadFileModel : true,
                        modelHeaderTitle: "intakeBookSubmission",  
                        acceptFileType: config.allowesCashRegisterFileExtentions             
                    } 
                })                           
            }
        }       
    }
    }

    const handlerOnIntakeBookSubmitClick = async (selectedRow, selectedIndex, isChangeRequest) => {  
        if(selectedRow && selectedRow.userIntakeBookFileName) 
        {
            if(isChangeRequest && selectedRow.changeRequest && 
                (!selectedRow.changeRequest.businessPartnerRemarks  || selectedRow.changeRequest.businessPartnerRemarks.trim() ===""))
            {
                    selectedRow.businessPartnerRemarks_ErrorMessage = "mandatory";
                    setChangeRequestData(selectedIndex, selectedRow.contractCode, selectedRow);
                    setErrorOrWarningHandler(true, "all_mandatory", false, true, "intakeBookSubmission", false, false); 
                    return;
            }
        ShowOrHideLoader(true);   
        let intakeBookDetailsRequest = new FormData();
        intakeBookDetailsRequest.append("BusinessPartnerCode", props.BusinessPartnerCode)
        intakeBookDetailsRequest.append("ContractCode", selectedRow.contractCode);
        intakeBookDetailsRequest.append("IntakeBookFile", selectedRow.intakeBookFile);
        intakeBookDetailsRequest.append("IntakeBookDate", format(parse(intakeBookStartDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy"));
        intakeBookDetailsRequest.append("CreatedBy", props.UserId); 
        intakeBookDetailsRequest.append("isChangeRequest" , !isChangeRequest ? false : isChangeRequest);
        if(isChangeRequest && selectedRow.changeRequest)
        {
            intakeBookDetailsRequest.append("monthlyInatakeBookId", selectedRow.id )
            intakeBookDetailsRequest.append("BusinessPartnerRemarks" , selectedRow.changeRequest.businessPartnerRemarks)  
        }
        await submitMonthlyIntakeBookDetails(intakeBookDetailsRequest)
        
            .then((data) => { 
                if(data && data.isSuccess && data.id > 0 )
                {
                    selectedRow ={
                        ...selectedRow,
                        isSubmitted: data.isSuccess, 
                        isFileUploadedError: !data.isSuccess,
                        id : data.id,
                        createdDate : data.createdDate,
                        intakeBookFileName : data.intakeBookFileName
                    }    
                    if (!isChangeRequest) {       
                        dispatch({ type: UPDATE_MONTHLY_INTAKE, 
                            payload: { 
                                selectedIntakeDtl: selectedRow,
                                selectedRowIndex : selectedIndex, 
                                changeRequestData: data
                            } 
                         })
                    }
                    else {
                        if(data.changeRequestNumber && data.changeRequestStatus && (!data.validationErrorMessage || data.validationErrorMessage === "")){
                            dispatch({ type: SUBMIT_CHANGE_REQUEST, 
                                payload: { 
                                    selectedIntakeDtl: selectedRow,
                                    selectedRowIndex : selectedIndex,
                                    changeRequestData: data  
                                } 
                         })
                            setChangeRequestNumber(data.changeRequestNumber)
                        }
                        else
                        {
                            setErrorOrWarningHandler(true, data.validationErrorMessage, false, true, "cr_submission", false, false);  
                            return;
                        }
                    }      

                    setErrorOrWarningHandler(false, !isChangeRequest ? "intakeBookSubmitted" : "cr_submitted_successfully", false, true, !isChangeRequest ? "intakeBookSubmission" : "cr_submission", false, true);
                }
                else{
                    setErrorOrWarningHandler(true,  "wentwrong", false, true, !isChangeRequest ? "intakeBookSubmission" : "cr_submission", false, false);  
                }
            })
            .catch((error) => {
                setErrorOrWarningHandler(true,  "wentwrong", false, true, !isChangeRequest ? "intakeBookSubmission" : "cr_submission", false, false); 
            })              
        }
        else{
            selectedRow ={
                ...selectedRow,
                isFileUploadedError: true               
            }
            dispatch({ type: UPDATE_MONTHLY_INTAKE, 
                payload: { 
                    selectedIntakeDtl: selectedRow,
                    selectedRowIndex : selectedIndex, 
                    changeRequestData : selectedRow
                } 
            })     
            setErrorOrWarningHandler(true, "all_mandatory", false, true, !isChangeRequest ? "intakeBookSubmission" : "cr_submission", false, false);
        }    
    }   

    const handlerOnUploadIntakeBookClick = (selectedUploadIndex, selectedIntakeUploadDtl, monthlyIntakeFile, userIntakeBookFileName) => {
        selectedIntakeUploadDtl={
            ...selectedIntakeUploadDtl,
            isFileUploaded: true,           
            intakeBookFile: monthlyIntakeFile, 
            userIntakeBookFileName: userIntakeBookFileName,
            isSelectionAllowed :true
        }
        dispatch({ type: UPDATE_MONTHLY_INTAKE, 
            payload: { 
                selectedIntakeDtl: selectedIntakeUploadDtl,
                selectedRowIndex : selectedUploadIndex, 
                changeRequestData : selectedIntakeUploadDtl                          
            } 
        }) 
        dispatch({ type: TOGGLE_UPLOAD_FILE_MODEL,
            payload: {
                showUploadFileModel : false,
                acceptFileType: "",
                modelHeaderTitle: ""
            } 
        });             
        setErrorOrWarningHandler(true, "cashregisteruploadedsuccessfully", false, true, "intakeBookSubmission", 
        true, false);        
    }    

    const handlerOnDeleteIntakeBookClick = (selectedDeleteIndex, selectedIntakeDeleteDtl) => {
        selectedIntakeDeleteDtl={
            ...selectedIntakeDeleteDtl,
            isFileUploaded: false,            
            intakeBookFile: null, 
            userIntakeBookFileName: null,
            isSelectionAllowed :false,
            isChecked : false
        }
        dispatch({
            type: UPDATE_MONTHLY_INTAKE,
            payload: {
            selectedRowIndex : selectedDeleteIndex,
            selectedIntakeDtl: selectedIntakeDeleteDtl
            }
        })
    }

    const resetIntakeBookFlags = () => {
        resetSubmittedAndErrorFlags();
        dispatch({ type: TOGGLE_UPLOAD_FILE_MODEL,
            payload: {
                showUploadFileModel : false,
                acceptFileType: "",
                modelHeaderTitle: ""
            } 
        });  
    }

    const handlerOnDownloadMonthlyIntakeBookClick = async (contractCode, intakeBookDate,
        userIntakeBookFileName, intakeBookFileName) => {
        await downloadMonthlyIntakeBookHandler(contractCode, intakeBookDate,
            userIntakeBookFileName, intakeBookFileName, setErrorOrWarningHandler, ShowOrHideLoader,
            downloadMonthlyIntakeBook);
    }

    const cancelChangeRequestHandler = async (index, selectedContractCode, selectedRevenueData) => {
        dispatch({
            type: CANCEL_CHANGE_REQUEST,
            payload: {
                selectedContractCodeIndex: index,
                selectedContractCode: selectedContractCode,
                changeRequestData: selectedRevenueData
            }
        });
    }

    const setChangeRequestData = async (index, selectedContractCode, selectedRowData) => {
        dispatch({
            type: SET_CHANGE_REQUEST_DATA,
            payload: {
                selectedContractCodeIndex: index,
                selectedContractCode: selectedContractCode,
                changeRequestData: selectedRowData
            }
        });
    }

    const checkBoxSelectionHandler = (index, selectedContractCode, selectedIntakeBookDetail) =>
    {
        dispatch({
            type: UPDATE_SELECTED_CHECKBOX,
            payload: {
            selectedRowIndex : index,
            selectedIntakeDtl: selectedIntakeBookDetail
            }
        })

    } 
    
    const submitSelectedIntakeFailedHandler = async (selectedUnsubmittedIntakes) => {
        dispatch({
            type: SUBMIT_SELECTED_INTAKE_BOOK_FAILED,
            payload: {
                submittedData : selectedUnsubmittedIntakes
            }
        })

    }

    const submitSelectedIntakeHandler = async (selectedUnsubmittedIntakes, intakeBookStartDt) => {
        ShowOrHideLoader(true); 
        let intakeBookDetailsRequest = new FormData();
		selectedUnsubmittedIntakes.map((d,index) => {
				intakeBookDetailsRequest.append("request[" + index + "].BusinessPartnerCode", props.BusinessPartnerCode)
				intakeBookDetailsRequest.append("request[" + index + "].ContractCode", d.contractCode);
                intakeBookDetailsRequest.append("request[" + index + "].ContractId", d.contractId);
			    intakeBookDetailsRequest.append("request[" + index + "].IntakeBookFile", d.intakeBookFile);
                intakeBookDetailsRequest.append("request[" + index + "].IntakeBookDate", format(parse(intakeBookStartDt, "dd/MM/yyyy", new Date()),"MM/dd/yyyy"));
                intakeBookDetailsRequest.append("request[" + index + "].CreatedBy", props.UserId); 
            }) 
        await submitSelectedDailyIntakeDetails(intakeBookDetailsRequest)
            .then((data) => {
                const isSuccessed = data && data.length > 0 && data.some(d=>d.id > 0) ;
                if(isSuccessed)
                {
                    dispatch({
                        type: SUBMIT_SELECTED_INTAKE_BOOK_SUCCESS,
                        payload: {
                            submittedData : data
                        }
                    })
                    setErrorOrWarningHandler(false, data.every(d=>d.id > 0) ? "intakeBookSubmitted" : "failed_message" , false, true,  "intakeBookSubmission", false, true , data.every(d=>d.id > 0) ? RequestStatus.Success.id : RequestStatus.Failed.id);
                }
                else
                {
                    if (data && data.length > 0) {
                        submitSelectedIntakeFailedHandler(data);
                    }
                    setErrorOrWarningHandler(true, "failed_message", false, true, "intakeBookSubmission" , false, false, RequestStatus.Failed.id ); 
                }
            })
            .catch((error) => {
                submitSelectedIntakeFailedHandler(selectedUnsubmittedIntakes);
                setErrorOrWarningHandler(true, "failed_message", false, true, "intakeBookSubmission" , false, false, RequestStatus.Failed.id); 
            })          
    }

    const setMonthlyDataHandler = (index, selectedContractCode, selectedRevenueData, isUnblockRequest) => {
        dispatch({ type: SET_SELECTEDINTAKEBOOK_DATA_REQUEST });
        dispatch({
            type: isUnblockRequest ? SET_SELECT_UNBLOCK_REQUEST_INTAKEBOOK : SET_SELECTEDINTAKEBOOK_DATA,
            payload: {
                selectedContractCodeIndex: index,
                selectedContractCode: selectedContractCode,
                selectedRevenue: selectedRevenueData
            }
        });
        
    }

    const resetMonthlyUnblockRequestFlag = (showUnblockModel, isResetSelectedRevenue) => {
        if(isResetSelectedRevenue) {
            dispatch({ type: SET_SELECTEDINTAKEBOOK_DATA_REQUEST });
        }
        
        if(showUnblockModel) {
            setChangeRequestNumber(null);
            setUnblockFromDateAndContractCode(null, null);
        }

        dispatch({ type: TOGGLE_MONTHLY_UNBLOCK_REQUEST_MODEL, 
            payload: {                        
                showUnblockMonthlyRequestModel : showUnblockModel             
            } 
        });
    }

    const handlerOnMonthlyUnblockRequestIconClick = (row, rowIndex) => {  
        if(row && !row.isSubmitted && !row.isMonthlySubmitted)
        {  
            setMonthlyDataHandler(rowIndex, row.contractCode, row, true)         
            resetMonthlyUnblockRequestFlag(true, false);
        }       
    }

    const onSubmitMonthlyUnblockRequestHandler = async (ev, submittedData) => {
        ShowOrHideLoader(true);
        setChangeRequestNumber(null);
        const unblockFromDt = submittedData.unblockChangeRequest ? submittedData.unblockChangeRequest.unblockFromDate : null;
        setUnblockFromDateAndContractCode(unblockFromDt, submittedData.contractCode);
        let requestData = {
            "businessPartnerCode": props.BusinessPartnerCode,
            "contractCode": submittedData.contractCode,
            "businessPartnerRemarks": submittedData.unblockChangeRequest.businessPartnerRemarks,
            "createdBy": props.UserId
        }

        await submitMonthlyUnblockContractRequest(requestData)
            .then((data) => {
                resetMonthlyUnblockRequestFlag(false, false);
                if(data && data.changeRequestNumber && data.changeRequestStatus && !data.validationErrorMessage) {
                    dispatch({
                        type: SUBMIT_MONTHLY_UNBLOCK_REQUEST,
                        payload: {
                            selectedContractCodeIndex: submittedData.index,
                            unblockRequestData: data 
                        }
                    });
                    setErrorOrWarningHandler(false, "", false, true, "cr_submission", false , data.changeRequestNumber !== "", RequestStatus.SuccessCr.id) 
                    setChangeRequestNumber(data.changeRequestNumber);
                } else {
                    if(data && ((data.changeRequestNumber && data.changeRequestNumber.trim() === "")
                            || (data.validationErrorMessage && data.validationErrorMessage.trim() !== ""))) {
                        dispatch({
                            type: MONTHLY_UNBLOCK_REQUEST_NOT_ALLOWED,
                            payload: {
                                selectedContractCodeIndex: submittedData.index,
                                selectedRevenue: submittedData
                            }
                        });
                        setErrorOrWarningHandler(true, data.validationErrorMessage, false, true, "cr_submission", false, false, RequestStatus.FailedCr.id);
                    } else {
                        setErrorOrWarningHandler(true, "wentwrong", false, true, "cr_submission", false, false, RequestStatus.FailedCr.id);
                    }
                }
            })
            .catch((error) => {
                resetMonthlyUnblockRequestFlag(false, false);
                setErrorOrWarningHandler(true, "wentwrong", false, true, "cr_submission", false, false, RequestStatus.FailedCr.id);
            })
    }

    const provider = {
        monthlyIntakeBookDetails,
        selectedIntakeDtl,
        selectedRowIndex,
        handlerOnIntakeBookIconClick,
        handlerOnIntakeBookSubmitClick,
        handlerOnUploadIntakeBookClick,
        handlerOnDeleteIntakeBookClick,
        handlerOnDownloadMonthlyIntakeBookClick,
        showUploadFileModel,
        acceptFileType,      
        modelHeaderTitle,
        resetIntakeBookFlags,
        cancelChangeRequestHandler, 
        setChangeRequestData,
        checkBoxSelectionHandler,
        submitSelectedIntakeHandler,
        setMonthlyDataHandler: setMonthlyDataHandler,
        showUnblockMonthlyRequestModel,
        handlerOnMonthlyUnblockRequestIconClick,
        resetMonthlyUnblockRequestFlag,
        onSubmitMonthlyUnblockRequestHandler
    }

    return (
        <MonthlyIntakeBookContext.Provider value={provider}>
            {props.children}
            {showPopup && <TranslationErrorPopup showPopup={showPopup} setShowPopup={setPopup} />}
        </MonthlyIntakeBookContext.Provider>
    );
}